import { createContext, useContext } from "react";

export interface GuideStepContextValue {
  guideId: string;
  stepIndex: number;
  onComplete: () => void;
  onDismiss: () => void;
  onNext?: () => void;
  onPrev?: () => void;
  stepIndicator?: string;
  isLast: boolean;
}

const GuideStepContext = createContext<GuideStepContextValue | null>(null);

export const useGuideStep = (): GuideStepContextValue => {
  const ctx = useContext(GuideStepContext);
  if (!ctx) throw new Error("useGuideStep must be used inside GuideSequence");
  return ctx;
};

export default GuideStepContext;
